import {ImgIcon} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcon';
import {ImgIcons} from '@mintdata/mint-kit/impl/properties/components/imgIcon/ImgIcons';
import {InlineLabel} from '@mintdata/mint-kit/impl/properties/components/inlineLabel/InlineLabel';
import {SelectedValue} from '@mintdata/mint-kit/impl/properties/components/selectedValue/SelectedValue';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('@mintdata/mint-kit/impl/properties/components/select/Select.less');
const cx = classnames.bind(styles);

export interface IProps
{
    children:any;
    inlineLabel?:string | JSX.Element;
    value:any;
    caption?:any;
    disabled?:boolean;
    isUppercased?:boolean;
    isOutlined?:boolean;
    onChange?:(e:any) => void;
    onFocus?:(e:any) => void;
    onBlur?:(e:any) => void;
    valueRenderer?:() => JSX.Element;
}

export class Select extends React.Component<IProps>
{

    public render():JSX.Element
    {
        const {
            children, inlineLabel, value, disabled, caption,
            onChange, onFocus, onBlur, isUppercased = false,
            isOutlined = false,
            valueRenderer = () => (
                <SelectedValue isUppercased={isUppercased} value={(caption || value).toString()} />
            ),
        } = this.props;

        return (
            <div className={styles.selectWrapper}>
                <select
                    className={cx(styles.select, {isOutlined})}
                    value={value}
                    disabled={disabled}
                    onChange={onChange}
                    onFocus={onFocus}
                    onBlur={onBlur}
                >
                    {children}
                </select>
                <div className={cx(styles.selectValueWrapper)}>
                    {
                        typeof inlineLabel === 'string' ? (
                            <InlineLabel className={styles.selectInlineLabel} text={inlineLabel} />
                        ) : inlineLabel
                    }
                    {valueRenderer()}
                    <ImgIcon icon={ImgIcons.chevronBottom} className={styles.arrowIcon} />
                    <ImgIcon icon={ImgIcons.chevronBottomActive} className={styles.arrowIconActive} />
                </div>
            </div>
        );
    }
}

